var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"white--text pr-2",attrs:{"dark":""}},[_c('v-spacer'),_vm._v("\n  💖 Proudly brought to you by "),_c('a',{attrs:{"href":"https://aiwebstudio.com","target":"_blank"}},[_vm._v("Active Improvement Web Studio")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da3d5934","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layouts/AppFooter.vue
// module id = 122
// module chunks = 1